import { ApiError } from "./ApiError";

export class ServerErrorException extends ApiError {
    constructor() {
        super();
    }
}